import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { Page, PageHeader } from '../ui'
import { ContractsView } from '../components/views/contractsView'

function Contracts() {
    return (
        <div className="contracts">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Sentinel Tools" title="Contracts" />
                    <ContractsView />
                </Page>
            </MainView>
        </div>
    )
}

export default Contracts
